export default {
  create: {
    method: 'post',
    url: '/client/route'
  },
  gets: {
    method: 'post',
    url: '/client/route/list'
  },
  deletes: {
    method: 'delete',
    url: '/client/route'
  },
  archive: {
    method: 'delete',
    url: '/client/route/archive'
  },
  get: {
    method: 'get',
    url: '/client/route/ID'
  },
  getRequest: {
    method: 'get',
    url: '/client/route/request/ID'
  },
  edit: {
    method: 'put',
    url: '/client/route/ID'
  }
}
